import { Injectable } from '@angular/core';
import { UnleashService } from '@snowfrog/ngx-unleash-proxy-client';
import FeatureToggleHelper from '../helpers/FeatureToggle.helper';
import { ENTITY_TYPE } from '../constants/CompanyOrFirm';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, from, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FeatureToggleService {
  private _orgAllowedChampionPermission$ = new BehaviorSubject<boolean>(false);
  public orgAllowedChampionPermission$ = this._orgAllowedChampionPermission$.asObservable();

  constructor(private unleashService: UnleashService) {}

  updateContext(organizationId: string): Promise<void> {
    return this.unleashService.updateContext({
      appName: environment.name,
      properties: {
        organizationId: organizationId,
        tenantId: environment.tenantId,
      },
    });
  }

  getOrgAllowedChampionPermission(organizationId: string): Observable<boolean> {
    return from(this.updateContext(organizationId)).pipe(
      map(() => {
        const permitted =
          this.organizationChampionPermission && this.unleashService.isEnabled(FeatureToggleHelper.organizationAllowedChampionPermissionToggle());
        this._orgAllowedChampionPermission$.next(permitted);
        return permitted;
      })
    );
  }

  get championPermission(): boolean {
    return this.unleashService.isEnabled(FeatureToggleHelper.championPermissionToggle());
  }

  get organizationChampionPermission(): boolean {
    return this.championPermission && this.unleashService.isEnabled(FeatureToggleHelper.championPermissionToggle(ENTITY_TYPE.ORGANISATION));
  }

  get projectChampionPermission(): boolean {
    return this.championPermission && this.unleashService.isEnabled(FeatureToggleHelper.championPermissionToggle(ENTITY_TYPE.PROJECT));
  }

  get portfolioChampionPermission(): boolean {
    return this.championPermission && this.unleashService.isEnabled(FeatureToggleHelper.championPermissionToggle(ENTITY_TYPE.PORTFOLIO));
  }

  get orgAllowedChampionPermission(): boolean {
    return this.organizationChampionPermission && this.unleashService.isEnabled(FeatureToggleHelper.organizationAllowedChampionPermissionToggle());
  }

  get modernizedDesign(): boolean {
    return this.unleashService.isEnabled(FeatureToggleHelper.modernizedDesignToggle());
  }
}
